// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"79eea2571904f1ec11bf","3539":"fab8c07a7f3208afabe0","5805":"4e714d6f30abbe1c8b1f"}[chunkId] + ".css";
};